import React from 'react'

function Contact() {
  return (
    <div id="contact" className="basic-2">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <h2 className="blue text-center">Get Started with AI Solutions</h2>
            <p className="text-center">Ready to transform your business with cutting-edge AI technology? Contact our experts today.</p>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="text-container">
              <h3>Schedule a Consultation</h3>
              <p>
                Our AI experts are ready to discuss your specific business challenges and opportunities. 
                Schedule a free consultation to learn how FalconEye AI Solutions can deliver measurable 
                productivity gains for your organization.
              </p>
              <ul className="list-unstyled li-space-lg">
                <li className="media">
                  <i className="fas fa-check"></i>
                  <div className="media-body">Free 30-minute consultation with AI experts</div>
                </li>
                <li className="media">
                  <i className="fas fa-check"></i>
                  <div className="media-body">Custom assessment of your AI readiness</div>
                </li>
                <li className="media">
                  <i className="fas fa-check"></i>
                  <div className="media-body">Detailed implementation roadmap</div>
                </li>
                <li className="media">
                  <i className="fas fa-check"></i>
                  <div className="media-body">ROI projections and timeline estimates</div>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="text-container">
              <h3>Contact Information</h3>
              <div className="contact-info">
                <div className="contact-item">
                  <strong>Business Inquiries:</strong><br />
                  <a href="mailto:business@falconeye.io">business@falconeye.io</a>
                </div>
                <br />
                <div className="contact-item">
                  <strong>Technical Support:</strong><br />
                  <a href="mailto:support@falconeye.io">support@falconeye.io</a>
                </div>
                <br />
                <div className="contact-item">
                  <strong>Partnership Opportunities:</strong><br />
                  <a href="mailto:partnerships@falconeye.io">partnerships@falconeye.io</a>
                </div>
                <br />
                <div className="contact-item">
                  <strong>Legal & Privacy:</strong><br />
                  <a href="mailto:legal@falconeye.io">legal@falconeye.io</a>
                </div>
              </div>
              <div className="text-center" style={{marginTop: '30px'}}>
                <a className="btn-solid-lg" href="mailto:business@falconeye.io">Schedule Consultation</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Contact

